import {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useCallback,
} from 'react'
import { useMediaQuery } from 'react-responsive'
import Collapsible from 'react-collapsible'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronDown,
  faChevronUp,
  faLightbulb,
  faAward,
  faCircleInfo,
  faPlus,
  faUser,
  faPenToSquare,
  faXmark,
  faNoteSticky,
} from '@fortawesome/free-solid-svg-icons'
import {
  renderHtml,
  getChoicesClass,
  getCurrentDimension,
  getMaxChoiceLength,
  getMaxLength,
  getFullDateHourString,
  maxCharachterWidth,
  getHighlighedCode,
  formatTime,
  getDifficultySpans,
  getIsPartiallyCorrect,
  formatExplanation,
  isAnswerCorrect,
} from '../../utils'

import '../../pages/grile/grile.css'
import HintModal from '../Grid/components/Modals/HintModal'
import Tooltip from '@mui/material/Tooltip'
import Latex from 'react-latex-next'
import MobileAwardModal from '../../pages/istoric/components/MobileAwardModal'
import InfoModal from '../Grid/components/Modals/InfoModal'
import ChoiceInput from '../ChoiceInput'
import { NavLink } from 'react-router-dom'
import NoteModal from '../Grid/components/Modals/NoteModal'

const GridPreview = ({
  historyType,
  grilaId,
  explicatie,
  cerinta,
  timestamp,
  indiciu,
  answer,
  userAnswer,
  tags,
  time,
  percent,
  difficulty,
  source,
  colorByDifficulty,
  createdByCurrentUser,
  addGrila,
  unSaveGrid,
  pagesAuto,
  pagesManual,
  books,
  book,
  note,
  handleUpdateNote,
  isMultipleChoice,
  explainAnswers,
}) => {
  const [isTriggered, setIsTriggered] = useState(false)
  const [hintModalOpened, setHintModalOpened] = useState(false)
  const [isNoteModalOpened, setIsNoteModalOpened] = useState(false)
  const [awardModalOpened, setAwardModalOpened] = useState(false)
  const [currentGrila, setCurrentGrila] = useState(undefined)
  const [screenSize, setScreenSize] = useState(getCurrentDimension())
  const [windowWidth, setWindowWidth] = useState(0)
  const [infoModalOpened, setInfoModalOpened] = useState(false)
  const [localNote, setLocalNote] = useState(note)

  const ref = useRef(null)
  const isTablet = useMediaQuery({
    query: '(max-width: 1200px)',
  })
  const handleCloseModalAfterSubmit = () => {
    setAwardModalOpened(false)
  }

  const handleOpenHintModal = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    setHintModalOpened(true)
  }, [])

  const handleChangeNote = useCallback(event => {
    const { value } = event.target
    setLocalNote(value)
  }, [])

  const handleOpenNoteModal = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    setIsNoteModalOpened(true)
  }, [])

  const handleStartSolving = useCallback(response => {
    const grila = JSON.parse(response)

    const newGrila = []
    for (let index = 0; index < grila.length; index++) {
      if (grila[index].type === 'matrix') {
        const matrixContainer = {
          type: 'matrix',
          content: [],
          maxSize: -1,
        }

        while (grila[index].type === 'matrix') {
          matrixContainer.content.push(grila[index].content)
          index += 1
        }

        matrixContainer.maxSize = getMaxLength(matrixContainer.content)
        newGrila.push(matrixContainer)

        if (index < grila.length) {
          newGrila.push(grila[index])
        }
      } else if (grila[index].type === 'text') {
        grila[index].content = renderHtml(grila[index].content)
        newGrila.push(grila[index])
      } else {
        newGrila.push(grila[index])
      }
    }
    setCurrentGrila(newGrila)
  }, [])

  useEffect(() => {
    const newMaxChoiceLength = getMaxChoiceLength(currentGrila)

    const choicesContainer = document.getElementById(
      `choices-container-${grilaId}`,
    )
    if (choicesContainer) {
      choicesContainer.classList = `mt-[10px] mb-[10px] gap-5 p-[10px] mr-auto sm:mt-[30px] sm:mb-[30px] ${getChoicesClass(
        windowWidth,
        newMaxChoiceLength,
      )}`
    }
  }, [currentGrila, grilaId, windowWidth])

  useEffect(() => {
    handleStartSolving(cerinta)
  }, [cerinta, handleStartSolving])

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension())
    }
    window.addEventListener('resize', updateDimension)
    return () => {
      window.removeEventListener('resize', updateDimension)
    }
  }, [])

  useEffect(() => {
    setLocalNote(note)
  }, [note])

  const handleOpenAwardModal = useCallback(e => {
    e.preventDefault()
    e.stopPropagation()
    setAwardModalOpened(true)
  }, [])

  const handleOpenInfoModal = useCallback(e => {
    e.preventDefault()
    e.stopPropagation()
    setInfoModalOpened(true)
  }, [])
  useLayoutEffect(() => {
    if (ref.current) {
      setWindowWidth(ref.current.offsetWidth)
    }
  }, [])

  const getHeaderColor = () => {
    if (colorByDifficulty) {
      if (createdByCurrentUser) {
        return 'bg-secondary-container-background'
      }

      if (difficulty >= 0 && difficulty < 0.29) {
        return 'bg-error'
      } else if (difficulty >= 0.29 && difficulty < 0.87) {
        return 'bg-partially-correct'
      } else {
        return 'bg-correct'
      }
    }
    if (isAnswerCorrect(userAnswer, answer)) {
      return 'bg-correct'
    }
    if (getIsPartiallyCorrect(answer, userAnswer)) {
      return 'bg-partially-correct'
    }

    return 'bg-error'
  }
  const percentAsNumber = parseInt(percent?.replace('%', ''))
  return (
    <div
      className={`min-h-[110px] sm:min-h-[140px] relative rounded border-[1px] border-brd-primary mt-[30px] bg-container-background
      ${
        historyType === 0 || historyType === 2
          ? 'w-full'
          : 'w-[90%] ml-auto mr-auto'
      }`}
      ref={ref}
    >
      {historyType === 0 || historyType === 2 ? (
        <div
          onClick={() => setIsTriggered(prev => !prev)}
          className={`text-[13px] p-[10px] cursor-pointer sm:h-[50px] h-[40px] text-white rounded-tr rounded-tl font-bold flex justify-between items-center ${getHeaderColor()}`}
        >
          {addGrila ? (
            <div className="w-[140px] flex justify-start">
              <Tooltip title="Adaugă grila">
                <FontAwesomeIcon
                  onClick={e => {
                    addGrila(grilaId)
                    e.stopPropagation()
                  }}
                  icon={faPlus}
                  className="h-[20px] mr-[15px] hover:white hover:transition-all sm:h-[30px]"
                />
              </Tooltip>
              <Tooltip title="Modifică grila">
                <NavLink to={`/creaza-grila#${grilaId}`}>
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    className="h-[20px] mr-[15px] hover:white hover:transition-all sm:h-[30px]"
                  />
                </NavLink>
              </Tooltip>
            </div>
          ) : null}
          {unSaveGrid ? (
            <div className="w-[140px] flex justify-start">
              <Tooltip title="Elimină grila">
                <FontAwesomeIcon
                  icon={faXmark}
                  onClick={e => {
                    unSaveGrid()
                    e.stopPropagation()
                  }}
                  className="h-[20px] mr-[15px] hover:white hover:transition-all sm:h-[30px]"
                />
              </Tooltip>
            </div>
          ) : null}
          <div className="font-bolder text-[15px] w-[140px]">
            {timestamp
              ? getFullDateHourString(new Date(timestamp * 1000))
              : null}
          </div>
          {time ? (
            <div className="w-[140px] text-[15px] ml-[20px] font-bolder flex justify-center items-center">
              {formatTime(time)}
            </div>
          ) : null}

          <div className="w-[140px] flex justify-end">
            {createdByCurrentUser === true && !isTablet ? (
              <Tooltip title="Grilă creată de tine">
                <FontAwesomeIcon
                  className="h-[20px] ml-[15px] hover:white hover:transition-all sm:h-[30px] hover:text-primary"
                  icon={faUser}
                />
              </Tooltip>
            ) : null}

            {indiciu && (
              <Tooltip
                title="Ai cerut indiciu pentru această grilă"
                onClick={handleOpenHintModal}
              >
                <FontAwesomeIcon
                  icon={faLightbulb}
                  className="h-[20px] ml-[15px] hover:opacity-70 hover:transition-all sm:h-[30px]"
                />
              </Tooltip>
            )}
            {historyType === 2 && (
              <Tooltip title="Notiță" onClick={handleOpenNoteModal}>
                <FontAwesomeIcon
                  icon={faNoteSticky}
                  className={`h-[20px] ml-[15px] hover:opacity-70 hover:transition-all sm:h-[30px]
                  ${!localNote?.length > 0 ? 'opacity-70' : 'opacity-100'}`}
                />
              </Tooltip>
            )}
            {tags && tags.length > 0 && (
              <Tooltip onClick={handleOpenInfoModal} title="Detalii">
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  className="h-[20px] ml-[15px] hover:opacity-70 hover:transition-all sm:h-[30px]"
                />
              </Tooltip>
            )}
            {userAnswer === answer && percent && percentAsNumber !== 100 ? (
              <Tooltip
                onClick={isTablet ? handleOpenAwardModal : () => {}}
                title={
                  percentAsNumber !== 0
                    ? `Ai fost in primii: ${percent}`
                    : 'Ai fost printre cei mai rapizi de pe platformă!'
                }
              >
                <FontAwesomeIcon
                  icon={faAward}
                  className="h-[20px] ml-[15px] hover:opacity-70 hover:transition-all sm:h-[30px]"
                />
              </Tooltip>
            ) : null}
          </div>
        </div>
      ) : (
        <div
          onClick={() => setIsTriggered(prev => !prev)}
          className="text-[13px] text-gray-500 border-b border-[#c2bfbf] pr-[10px] py-[10px] cursor-pointer sm:h-[50px] h-[40px] rounded-tr rounded-tl font-bold flex justify-between items-center"
        >
          <div
            className={`h-[40px] ${
              historyType === 0
                ? 'rounded-tr rounded-tl w-full'
                : 'rounded-tl  sm:h-[50px] h-[40px] w-[60px]'
            } ${getHeaderColor()}`}
          ></div>
          <div className="w-[140px] flex justify-end">
            {indiciu && (
              <Tooltip
                title="Ai cerut indiciu pentru această grilă"
                onClick={handleOpenHintModal}
              >
                <FontAwesomeIcon
                  onClick={handleOpenHintModal}
                  icon={faLightbulb}
                  className="h-[20px] text-over-ternary-background hover:text-primary hover:transition-all sm:h-[30px]"
                />
              </Tooltip>
            )}
            {tags && tags.length > 0 && (
              <Tooltip onClick={handleOpenInfoModal} title="Detalii">
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  className="h-[20px] ml-[15px] text-over-ternary-background hover:text-primary hover:transition-all sm:h-[30px]"
                />
              </Tooltip>
            )}
          </div>
        </div>
      )}
      <Collapsible
        triggerClassName="!text-over-ternary-background"
        contentInnerClassName="bg-container-background"
        open={isTriggered}
        contentOuterClassName="grila-closed-content"
        trigger={
          isTriggered ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )
        }
        onOpening={() => setIsTriggered(true)}
        onClosing={() => setIsTriggered(false)}
      >
        <div className="p-[10px] text-[13px] leading-[1.1]">
          {currentGrila &&
            currentGrila.map((item, index) => {
              if (item?.type === 'text') {
                return (
                  <div
                    key={`text-${index}`}
                    className={`md:text-[14px] leading-[0.98] xs:leading-[1.1]  pb-1 text-over-secondary-background ${
                      isTriggered ? 'h-full' : 'h-[32px] overflow-hidden'
                    }`}
                  >
                    <Latex> {item.content} </Latex>
                  </div>
                )
              } else if (item?.type === 'code') {
                return (
                  <pre key={`code-${index}`} className="mt-[25px] mb-[20px]">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: getHighlighedCode(item?.content),
                      }}
                      className="text-[14px] cpp hljs text-over-secondary-background"
                    ></div>
                  </pre>
                )
              } else if (item?.type === 'matrix') {
                const numberOfChoices = Math.floor(
                  (screenSize.width - 20) /
                    (maxCharachterWidth * item?.maxSize),
                )
                return (
                  <div
                    key={`matrix-${index}`}
                    className="mt-[20px] grid mb-[20px] gap-y-[20px] gap-x-[30px]"
                    style={{
                      gridTemplateColumns: `repeat(${Math.min(
                        numberOfChoices,
                        item?.content?.length,
                      )}, 1fr)`,
                      color: 'red',
                    }}
                  >
                    {item?.content?.map((matrix, idx) => {
                      return (
                        <pre key={`matrix-${idx}`}>
                          <div className="test-[14px] cpp hljs text-over-secondary-background">
                            {matrix}
                          </div>
                        </pre>
                      )
                    })}
                  </div>
                )
              }
            })}
        </div>
        <div id={`choices-container-${grilaId}`}>
          {currentGrila &&
            currentGrila.map((item, index) => {
              if (item?.type?.includes('choice-')) {
                const choiceIndex = parseInt(item?.type[item?.type?.length - 1])

                const isCorrectAnswered = isMultipleChoice
                  ? answer?.toString().includes(choiceIndex.toString())
                  : answer === choiceIndex

                const isIncorrectAnswered = isMultipleChoice
                  ? userAnswer?.toString().includes(choiceIndex.toString()) &&
                    !answer?.toString().includes(choiceIndex.toString())
                  : userAnswer === choiceIndex && userAnswer !== answer
                return (
                  <div
                    key={`choice-container-${index}`}
                    className={`flex flex-col p-4 ${
                      isCorrectAnswered
                        ? 'bg-correct'
                        : isIncorrectAnswered
                          ? 'bg-error'
                          : 'bg-transparent'
                    }`}
                  >
                    <div className="flex flex-row gap-3">
                      <ChoiceInput
                        isMultipleChoice={isMultipleChoice}
                        className={
                          (isMultipleChoice
                            ? answer
                                ?.toString()
                                .includes(choiceIndex.toString())
                            : answer === choiceIndex) &&
                          '!bg-primary !text-white'
                        }
                        disabled
                        choice={String.fromCharCode(choiceIndex + 65)}
                      />

                      <label
                        htmlFor={`choice-${grilaId}-${
                          item?.type[item?.type?.length - 1]
                        }`}
                      >
                        <div className="flex text-over-secondary-background ">
                          {item?.type?.includes('code') && (
                            <pre>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: getHighlighedCode(item?.content),
                                }}
                                className="pl-[7px] text-over-secondary-background tracking-[0.2px] text-[14px] md:pl[10px] md:tracking-[1px]  cpp"
                              ></div>
                            </pre>
                          )}
                          {item?.type?.includes('matrix') && (
                            <pre>
                              <div className="pl-[7px] text-over-secondary-background tracking-[0.2px] text-[14px] md:pl[10px] md:tracking-[1px]   cpp">
                                {item?.content}
                              </div>
                            </pre>
                          )}
                          {!item?.type?.includes('code') &&
                            !item?.type?.includes('matrix') && (
                              <Latex className="text-[14px] text-over-secondary-background tracking-[0] pl-[7px]">
                                {' '}
                                {renderHtml(item.content)}{' '}
                              </Latex>
                            )}
                        </div>
                      </label>
                    </div>

                    {explainAnswers &&
                      explainAnswers[`choice-${index - 1}`] && (
                        <p
                          className="m-0 ml-[35px] text-sm text-over-primary-background"
                          dangerouslySetInnerHTML={{
                            __html: formatExplanation(
                              explainAnswers[`choice-${index - 1}`],
                              books,
                              book,
                            ),
                          }}
                        />
                      )}
                  </div>
                )
              }
            })}
        </div>
        <div className="w-[90%] m-[20px]">
          {explicatie && (
            <div className="mt-[5px] text-[14px] text-over-secondary-background leading-[1.4]">
              <b>Explicație: </b>
              <Latex>{formatExplanation(explicatie, books, book)}</Latex>
            </div>
          )}
        </div>
      </Collapsible>

      {indiciu ? (
        <HintModal
          hintModalOpened={hintModalOpened}
          handleCloseHintModal={() => setHintModalOpened(false)}
          hint={indiciu}
        />
      ) : null}
      <MobileAwardModal
        handleCloseAwardModal={handleCloseModalAfterSubmit}
        mobileModalAwardOpened={awardModalOpened}
        percent={percent}
      />

      <InfoModal
        pagesAuto={pagesAuto}
        pagesManual={pagesManual}
        book={book}
        gridId={grilaId}
        source={source}
        openInfoModal={infoModalOpened}
        handleCloseInfoModal={() => setInfoModalOpened(false)}
        gridTags={tags}
        difficulty={getDifficultySpans(difficulty)}
        createdByCurrentUser={createdByCurrentUser}
      />

      <NoteModal
        handleUpdateNote={() => handleUpdateNote(grilaId, localNote)}
        modify
        handleClose={() => setIsNoteModalOpened(false)}
        isOpened={isNoteModalOpened}
        handleChangeNote={handleChangeNote}
        note={localNote}
      />
    </div>
  )
}
export default GridPreview
